export var ProgramExportStdoutTypes;
(function (ProgramExportStdoutTypes) {
    ProgramExportStdoutTypes["STDOUT_START"] = "EXPORT_STDOUT_START";
    ProgramExportStdoutTypes["STDOUT_END"] = "EXPORT_STDOUT_END";
    ProgramExportStdoutTypes["STDOUT_MSG"] = "EXPORT_STDOUT_MSG";
})(ProgramExportStdoutTypes || (ProgramExportStdoutTypes = {}));
export var ProgramImportStdoutTypes;
(function (ProgramImportStdoutTypes) {
    ProgramImportStdoutTypes["STDOUT_START"] = "IMPORT_STDOUT_START";
    ProgramImportStdoutTypes["STDOUT_END"] = "IMPORT_STDOUT_END";
    ProgramImportStdoutTypes["STDOUT_MSG"] = "IMPORT_STDOUT_MSG";
})(ProgramImportStdoutTypes || (ProgramImportStdoutTypes = {}));
//# sourceMappingURL=ProgramImportExportStdout.js.map